import { render, staticRenderFns } from "./ChatOverview.vue?vue&type=template&id=61b57758&"
import script from "./ChatOverview.vue?vue&type=script&lang=js&"
export * from "./ChatOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports